import { assert } from '@varos/util-typescript';
import { ReportingShellLoaderBaseConfig } from '../../../base';
import { ChatErrorLoader } from './chatErrorInterface';
import { ChatLayoutAggregate } from './chatErrorModel';
import { useMemo } from 'react';

export function createChatErrorLoader(
    config: ReportingShellLoaderBaseConfig
): ChatErrorLoader {
    const {
        repository: { research, platform },
    } = config;
    return {
        useLoad(context, props): ChatLayoutAggregate {
            return {};
        },
    };
}
